const DEVICE_ID_KEY = 'crabs_device_id';

/**
 * UUID v4 생성 (crypto.randomUUID 미지원 환경 폴백)
 */
const generateUUID = (): string => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  // crypto.getRandomValues는 Secure Context 없이도 사용 가능
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // variant 1
  return [...bytes]
    .map((b, i) =>
      [4, 6, 8, 10].includes(i)
        ? `-${b.toString(16).padStart(2, '0')}`
        : b.toString(16).padStart(2, '0'),
    )
    .join('');
};

/**
 * 디바이스 고유 ID를 반환합니다.
 * localStorage에 저장되어 같은 브라우저에서 동일한 ID를 유지합니다.
 * 같은 사무실(같은 IP)에서 다른 PC를 구분하는 데 사용됩니다.
 */
export const getDeviceId = (): string => {
  if (typeof window === 'undefined') return '';

  try {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (!deviceId) {
      deviceId = generateUUID();
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  } catch (e) {
    console.warn('[device-id] getDeviceId 실패:', e);
    return '';
  }
};
